import { Component, OnInit, OnDestroy, Input, OnChanges, SimpleChange, ChangeDetectionStrategy, EventEmitter, Output } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormGroup }                 from '@angular/forms';
import { NgForm } from '@angular/forms';
import { SeguridadService } from '../_services/seguridad.service'
import { Subscription } from 'rxjs/Subscription';

import { NormasService } from '../_services/normas.service';
import { EvidenciasService } from '../_services/evidencias.service';
import { Evidencia } from '../_models/evidencia.model';
declare var jQuery:any;

import { GlobalEventsManager } from "../_services/globaleventsmanager.service";
import { ConfirmationService } from 'primeng/primeng';
import * as ClassicEditor from '@ckeditor/ckeditor5-build-classic'; 




@Component({
  selector: 'formularioevidencias',
  templateUrl: 'formularioevidencias.template.html'
})
export class FormularioEvidenciasComponent  implements OnInit, OnDestroy, OnChanges {

  @Input() idevidencia: any;
  @Input() idnorma: any;
  @Input() copiaevidencia: boolean;
  @Input() ventanapadre: number;
  @Input() puedoeditar: boolean;

  @Output() onChangeEvidencia = new EventEmitter<any>();
  @Output() onCloseEvidencia = new EventEmitter<number>();

  id_evidencia: number;
  id_norma: number;
  ventana_padre: number;

  subscription: Subscription;

  evidencia: Evidencia;
  evidencia_inicial: Evidencia;

  listarelevancias: number[] = [0,1,2,3,4,5,6,7,8,9,10];

  listaniveldeseguridad: any;
  listamodulosevidencias: any;
  listaafectapersonalmaquinaria: any;
  listaasignacion: any;
  listanivelelemento: any;
  listanivelseguridad: any;
  listatipocomentario: any;
  listatiposancion: any;
  listaenlacesnorma: any;

  emisorcambio: any = {
    anadir: false,
    change: false
  }

  alertaguardado: boolean = false;
  hayCambios: boolean = false;

  etiquetaevidencia: string = "";

  iconocerrar: string = 'fa fa-times';
  iconoexpandir: string = 'fa fa-expand';

  formularioEdit: NgForm;
  eventEdit: Event;
  public Editor = ClassicEditor;
  constructor(private seguridad: SeguridadService,
              private router:Router,
              private evidenciasService: EvidenciasService,
              private normasService: NormasService,
              private globalEventsManager: GlobalEventsManager,
              private activatedRoute: ActivatedRoute,
              private confirmationService: ConfirmationService,){

  }

  ngOnInit(){

    this.seguridad.getLogado();

    this.subscription = this.seguridad.dejoPasarUsuarioEmitter.subscribe((mode)=>{
            if (mode !== null) {
              if (!mode){
                this.router.navigate(['login']);
              }
            }
        });

    this.getLista("ListagetModuloEvidencias");
    this.getLista("ListagetEvidenciaAPERMAQ");
    this.getLista("ListagetEvidenciaAsignacion");
    this.getLista("ListagetEvidenciaNivelElemento");
    this.getLista("ListagetEvidenciaNivelSeguridad");
    this.getLista("ListagetEvidenciaComentarioTipo");
    this.getLista("ListagetTipoSancion");


  }

  cerrarEvidencia(destino:number){

    /*console.log(JSON.stringify(this.evidencia));
    console.log(JSON.stringify(this.evidencia_inicial));*/

    if (JSON.stringify(this.evidencia) === JSON.stringify(this.evidencia_inicial)){
      this.alertaguardado = false;
      this.cerrarVentana();
    }else{
      this.alertaguardado = true;
      jQuery(".columna").animate({scrollTop: 0}, 500);
    }
  }

  cerrarVentana(){
    this.onCloseEvidencia.emit(this.ventana_padre);
  }

  actualizaPadre(){
    //this.onChangeEvidencia.emit(true);
    this.onChangeEvidencia.emit(this.emisorcambio);
    if (this.emisorcambio.anadir){
      this.getEvidencia(0);
    }
  }


  ngOnChanges(changes: {[ propName: string]: SimpleChange}){
    if (changes['idevidencia']){
      this.id_evidencia = changes['idevidencia'].currentValue;
    }
    if (changes['idnorma']){
      this.id_norma = changes['idnorma'].currentValue;
    }
    if (changes['copiaevidencia']){
      this.copiaevidencia = changes['copiaevidencia'].currentValue;
    }
    if (changes['ventanapadre']){
      this.ventana_padre = changes['ventanapadre'].currentValue;
    }

    this.getEvidencia(this.id_evidencia);

    if (this.id_evidencia == 0){
      this.etiquetaevidencia = "Nueva evidencia";
    }else{
      this.etiquetaevidencia = "Editar evidencia";
    }

    if (!this.puedoeditar){
      this.etiquetaevidencia = "Evidencia";
    }



  }

  getIdentNorma(id_norma: number){
    this.normasService.getIdentNorma(id_norma).subscribe(
      data => {
        if (data){

          this.evidencia.norma = data.json().norma.normaAbr;
          this.evidencia.bloque = data.json().norma.bloqueAbr;
          this.evidencia.area = data.json().norma.areaAbr;
          this.evidencia.modulo = data.json().norma.moduloAbr;


          this.evidencia_inicial.norma = this.evidencia.norma;
          this.evidencia_inicial.bloque = this.evidencia.bloque;
          this.evidencia_inicial.area = this.evidencia.area;
          this.evidencia_inicial.modulo = this.evidencia.modulo;

          console.log(this.evidencia);

        }
      }
    );
  }

  ngOnDestroy(){
    this.subscription.unsubscribe();
  }

  onSubmit(formulario: NgForm, event: Event){

    event.preventDefault;

    let evidencia: any;

    evidencia = {
      id_evidencia : this.evidencia.id_evidencia,
      abr: this.evidencia.abr,
      descripcion: this.evidencia.descripcion,
      articulado: this.evidencia.articulado,
      codigo: this.evidencia.codigo,
      periodicidad: this.evidencia.periodicidad,
      periodicidadrecomendada: this.evidencia.periodicidadrecomendada,
      referencia: this.evidencia.referencia,
      relevancia: this.evidencia.relevancia,
      riesgomax: this.evidencia.riesgomax,
      riesgomin: this.evidencia.riesgomin,
      infraccion: this.evidencia.infraccion,
      comentarios_infraccion: this.evidencia.comentarios_infraccion,
      id_modev: this.evidencia.id_modev,
      id_persmaq: this.evidencia.id_persmaq,
      id_asignacion: this.evidencia.id_asignacion,
      id_nivelelemento: this.evidencia.id_nivelelemento,
      id_nivelseguridad: this.evidencia.id_nivelseguridad,
      comentarios: this.evidencia.comentarios,
      modoexplicito: this.evidencia.modoexplicito,
      periodicidadtipo: this.evidencia.periodicidadtipo,
      preaviso: this.evidencia.preaviso,
      id_norma: this.id_norma,
      id_tipo_sancion: this.evidencia.id_tipo_sancion,
      causaperiodicidad : this.evidencia.causaperiodicidad,
      cuestioncondicionada : this.evidencia.cuestioncondicionada
    };

    console.log(evidencia);

    this.copiaevidencia = false;

    this.evidenciasService.setEvidencia(evidencia).subscribe(
      data => {

        if (data){
          console.log (data.json());

          let al: any = {
            "texto" : "Evidencia guardada",
            "mostrar": true
          };
          this.globalEventsManager.setAlert(al);

          this.updateEvidencia(data);
        }

      }
    );
  }

  guardarAnadir(formulario: NgForm, event: Event){

    this.emisorcambio.anadir = true;
    this.onSubmit(formulario,event);
  }


  confirmarGuardar(formulario: NgForm, event: Event){
    
    this.checkCambios();

    if (this.hayCambios == true){
      this.formularioEdit = formulario;
      this.eventEdit = event;          


    }else{
      console.log('no hay cambios');
      this.guardar(formulario,event);
    }
  }




  guardar(formulario: NgForm, event: Event){

    this.emisorcambio.anadir = false;
    this.onSubmit(formulario,event);

  }

  //-Comprobamos que se ha hecho alguna modificación en la evidencia
  checkCambios(){
    if (JSON.stringify(this.evidencia) === JSON.stringify(this.evidencia_inicial)){
      this.hayCambios = false;

    }else{
      this.hayCambios = true;

    }
  }
  
  //-Cuando regresamos de la pantalla modalevidenciasempresas
  onChangeModal(event){
    if (event == 1){
      this.guardar(this.formularioEdit,this.eventEdit);
      
    }else{
      this.hayCambios = false;
      this.alertaguardado = true;
      jQuery(".columna").animate({scrollTop: 0}, 500);
    }
  }



  getEvidencia(id_evidencia){

    this.evidencia = new Evidencia();
    this.evidencia_inicial = new Evidencia();

    if (id_evidencia != 0){

      this.evidenciasService.getEvidencia(id_evidencia).subscribe(
        data => {
          if (data){
            console.log(data.json().evidencia);
            this.updateCampos(data);
          }
        }
      );

    }else{
      this.getIdentNorma(this.id_norma);
    }

  }

  updateCampos(data){
    this.evidencia.abr = data.json().evidencia.abr;
    this.evidencia.descripcion = data.json().evidencia.descripcion;
    this.evidencia.id_evidencia = data.json().evidencia.id_evidencia;
    this.evidencia.articulado = data.json().evidencia.articulado;
    this.evidencia.codigo = data.json().evidencia.codigo;
    this.evidencia.periodicidad = data.json().evidencia.periodicidad;
    this.evidencia.periodicidadrecomendada = data.json().evidencia.periodicidadrecomendada;
    this.evidencia.referencia = data.json().evidencia.referencia;
    this.evidencia.relevancia = data.json().evidencia.relevancia;
    this.evidencia.riesgomax = data.json().evidencia.riesgomax;
    this.evidencia.riesgomin = data.json().evidencia.riesgomin;
    this.evidencia.infraccion = data.json().evidencia.infraccion;
    this.evidencia.comentarios_infraccion = data.json().evidencia.comentarios_infraccion;
    this.evidencia.id_modev = data.json().evidencia.id_modev;
    this.evidencia.id_persmaq = data.json().evidencia.id_persmaq;
    this.evidencia.id_asignacion = data.json().evidencia.id_asignacion;
    this.evidencia.id_nivelelemento = data.json().evidencia.id_nivelelemento;
    this.evidencia.id_nivelseguridad = data.json().evidencia.id_nivelseguridad;
    this.evidencia.comentarios = data.json().evidencia.comentarios;
    this.evidencia.preaviso = data.json().evidencia.preaviso;

    this.evidencia.moduloevidenciadesc = data.json().evidencia.moduloevidenciaDesc;
    this.evidencia.afpermaqdesc = data.json().evidencia.afpermaqDesc;
    this.evidencia.asignaciondesc = data.json().evidencia.asignacionDesc;
    this.evidencia.nivelelementodesc = data.json().evidencia.nivelelementoDesc;
    this.evidencia.nivelseguridaddesc = data.json().evidencia.nivelseguridadDesc;
    this.evidencia.tiposanciondesc = data.json().evidencia.tiposancionDesc;
    this.evidencia.id_tipo_sancion = data.json().evidencia.id_tipo_sancion;

    this.evidencia.modoexplicito = data.json().evidencia.modoexplicito;
    this.evidencia.periodicidadtipo = data.json().evidencia.periodicidadtipo;

    this.evidencia.causaperiodicidad = data.json().evidencia.causaperiodicidad;
    this.evidencia.cuestioncondicionada = data.json().evidencia.cuestioncondicionada;

    this.evidencia.id_norma = this.id_norma;

    this.getIdentNorma(this.evidencia.id_norma);



    for (let i=0; i < this.evidencia.comentarios.length; i++){
      this.evidencia.comentarios[i].visible = true;
    }

    if (this.copiaevidencia){
      this.evidencia.id_evidencia = 0;
      this.evidencia.abr = "(Copia) " + this.evidencia.abr;
      this.evidencia.descripcion = "(Copia) " + this.evidencia.descripcion;
    }



    this.evidencia_inicial.abr = this.evidencia.abr;
    this.evidencia_inicial.descripcion = this.evidencia.descripcion;
    this.evidencia_inicial.id_evidencia = this.evidencia.id_evidencia;
    this.evidencia_inicial.articulado = this.evidencia.articulado;
    this.evidencia_inicial.codigo = this.evidencia.codigo;
    this.evidencia_inicial.periodicidad = this.evidencia.periodicidad;
    this.evidencia_inicial.periodicidadrecomendada = this.evidencia.periodicidadrecomendada;
    this.evidencia_inicial.referencia = this.evidencia.referencia;
    this.evidencia_inicial.relevancia = this.evidencia.relevancia;
    this.evidencia_inicial.riesgomax = this.evidencia.riesgomax;
    this.evidencia_inicial.riesgomin = this.evidencia.riesgomin;
    this.evidencia_inicial.infraccion = this.evidencia.infraccion;
    this.evidencia_inicial.comentarios_infraccion = this.evidencia.comentarios_infraccion;
    this.evidencia_inicial.id_modev = this.evidencia.id_modev;
    this.evidencia_inicial.id_persmaq = this.evidencia.id_persmaq;
    this.evidencia_inicial.id_asignacion = this.evidencia.id_asignacion;
    this.evidencia_inicial.id_nivelelemento = this.evidencia.id_nivelelemento;
    this.evidencia_inicial.id_nivelseguridad = this.evidencia.id_nivelseguridad;
    this.evidencia_inicial.comentarios = this.evidencia.comentarios;
    this.evidencia_inicial.preaviso = this.evidencia.preaviso;

    this.evidencia_inicial.moduloevidenciadesc = this.evidencia.moduloevidenciadesc;
    this.evidencia_inicial.afpermaqdesc = this.evidencia.afpermaqdesc;
    this.evidencia_inicial.asignaciondesc = this.evidencia.asignaciondesc;
    this.evidencia_inicial.nivelelementodesc = this.evidencia.nivelelementodesc;
    this.evidencia_inicial.nivelseguridaddesc = this.evidencia.nivelseguridaddesc;
    this.evidencia_inicial.tiposanciondesc = this.evidencia.tiposanciondesc;
    this.evidencia_inicial.id_tipo_sancion = this.evidencia.id_tipo_sancion;

    this.evidencia_inicial.modoexplicito = this.evidencia.modoexplicito;

    this.evidencia_inicial.periodicidadtipo = this.evidencia.periodicidadtipo;

    this.evidencia_inicial.id_norma = this.id_norma;

    this.evidencia_inicial.causaperiodicidad = this.evidencia.causaperiodicidad;
    this.evidencia_inicial.cuestioncondicionada = this.evidencia.cuestioncondicionada;

    console.log("entro");
    console.log(this.evidencia);

    this.getNorma(this.id_norma);

  }

  updateEvidencia(data){
    this.evidencia = new Evidencia();
    this.updateCampos(data);
    this.actualizaPadre();
  }

  getLista(accion: string){
    this.evidenciasService.getLista(accion).subscribe(
      data => {
        if (data){

          let json = data.json();

          if (accion == ""){
            this.listaniveldeseguridad = json.lista;
          }
          if (accion == "ListagetModuloEvidencias"){
            this.listamodulosevidencias = json.lista;
          }
          if (accion == "ListagetEvidenciaAPERMAQ"){
            this.listaafectapersonalmaquinaria = json.lista;
          }
          if (accion == "ListagetEvidenciaAsignacion"){
            this.listaasignacion = json.lista;
          }
          if (accion == "ListagetEvidenciaNivelElemento"){
            this.listanivelelemento = json.lista;
          }
          if (accion == "ListagetEvidenciaNivelSeguridad"){
            this.listanivelseguridad = json.lista;
          }
          if (accion == "ListagetEvidenciaComentarioTipo"){
            this.listatipocomentario = json.lista;
          }
          if (accion == "ListagetTipoSancion"){
            this.listatiposancion = json.lista;
          }
        }
      }
    );
  }

  anadirComentario(){
    var nuevocomentario: any = { id_tipo: "1", id_comentario: 0, comentario: "", visible: true };
    this.evidencia.comentarios.push(nuevocomentario);
  }

  borrarComentario(i){
    this.evidencia.comentarios[i].visible = false;
    this.evidencia.comentarios[i].comentario = "";
  }

  editar(){
    this.puedoeditar = true;
    this.etiquetaevidencia = "Editar evidencia";
  }

  cambiaRelevancia(){
    if (this.evidencia.relevancia >= 5){
      this.evidencia.id_nivelseguridad = 1;
    }else{
      this.evidencia.id_nivelseguridad = 2;
    }
  }

  getNorma(id_norma){

    this.normasService.getNorma(id_norma).subscribe(
      data => {

        if (data){
          this.listaenlacesnorma = data.json().norma.enlaces;
        }

      }
    );
  }





}



// WEBPACK FOOTER //
// ./src/app/evidencias/formularioevidencias.component.ts